import React from 'react';

import Misc from './Misc.svg';

import { SingleMsgCheck } from '../../styles';

const SingleMsgPrompt = ({
  singleMessage,
  setSingleMessage,
  handleSingleMessage,
  selection,
  firstMsg,
  isMobile,
  focusedProduct,
}) => {


  const handleClick = () => {
    setSingleMessage(!singleMessage);
    if (isMobile) {
      handleSingleMessage(
        selection.find((item) => item.bId === firstMsg).message
      );
    } else {
      focusedProduct
        ? handleSingleMessage(
            selection.find((item) => item.bId === focusedProduct.bId).message
          )
        : null;
    }
  };

  return (
    <SingleMsgCheck
      $isMobile={isMobile}
      onClick={() => {
        handleClick();
      }}
    >
      <span className="single-msg-check__prompt">Add to all?</span>
      <span
        className={`single-msg-check__checkbox ${
          singleMessage ? 'active' : ''
        }`}
      >
        {Misc.SingleMsgTick}
      </span>
    </SingleMsgCheck>
  );
};

export default SingleMsgPrompt;
